export enum PresenterState {
  Loading,
  Ready,
  Error,
  SwappingProviders,
}
